import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import RegistrationContainer from "./RegistrationContainer";
import TermsModal from "../components/TermsModal";
import { useAuth } from "../service";

export const Register = () => {
  const [verificationCode, setVerificationCode] = useState("");
  const [realCode, setRealCode] = useState("");
  const [isMobileVerified, setIsMobileVerified] = useState(false);
  const [firstname, setFirstName] = useState("");
  const [secondname, setSecondName] = useState("");
  const [username, setUsername] = useState("");
  const [birth_date, setBirthDate] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { register, sendverificationcode } = useAuth();

  const getValueCode = async (phone) => {
    try {
      const result = await sendverificationcode.mutateAsync(phone);
      return result || "Error retrieving verification code";
    } catch (error) {
      console.error("Error getting verification code:", error);
      return "Error retrieving verification code";
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !email ||
      !username ||
      !firstname ||
      !secondname ||
      !phone ||
      !password ||
      !confirmPassword ||
      !birth_date
    ) {
      setError("Please fill in all fields.");
      return;
    }
    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }
    setError("");
    const RealCode = await getValueCode(phone);
    setRealCode(RealCode);
  };

  const handleVerifyCode = async () => {
    if (verificationCode === "") {
      setError("Please enter the verification code.");
      return;
    }

    let isVerified = false;

    if (realCode === verificationCode) {
      isVerified = true;
    }

    if (isVerified) {
      register.mutate(
        firstname,
        secondname,
        username,
        birth_date,
        phone,
        email,
        password,
        rememberMe
      );
      setIsMobileVerified(true);
      setRealCode("");
      setError("");
      setFirstName("");
      setSecondName("");
      setPhone("");
      setEmail("");
      setUsername("");
      setBirthDate("");
      setPassword("");
      setConfirmPassword("");
      setRememberMe(false);
      setVerificationCode("");
      navigate("/login");
    } else {
      setError("Invalid verification code. Please try again.");
    }
  };

  return (
    <div className="vh-100 w-100 position-relative">
      {realCode === "" && (
        <div
          className="card p-0 shadow-lg"
        >
          <RegistrationContainer />
        </div>
      )}

      {!isMobileVerified && realCode !== "" && (
        <div className="d-flex justify-content-center align-items-center w-100">
          <div
            className="card p-4 shadow-lg"
            style={{
              width: "350px",
              borderRadius: "15px",
              background: "white",
            }}
          >
            {error && <div className="alert alert-danger">{error}</div>}
            <label className="form-label text-center">
              Enter Verification Code
            </label>
            <input
              type="text"
              className="form-control"
              value={verificationCode}
              onChange={(e) => setVerificationCode(e.target.value)}
            />
            <button className="btn btn-success mt-2" onClick={handleVerifyCode}>
              Verify Code
            </button>
          </div>
        </div>
      )}
      {/* {realCode === "" && (
                <div className="d-flex justify-content-center align-items-center w-100">
                    <div
                        className="card p-4 shadow-lg"
                        style={{
                            width: "350px",
                            borderRadius: "15px",
                            background: "white",
                        }}
                    >
                        <h3 className="fw-bold" style={{ color: "#898989" }}>
                            PayApp
                        </h3>
                        <p>Register new account.</p>

                        {error && (
                            <div className="alert alert-danger">{error}</div>
                        )}
                        {auth.error && (
                            <div className="alert alert-danger">
                                {auth.error}
                            </div>
                        )}

                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <label className="form-label-always-active color-highlight font-11">
                                    FirstName
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={firstname}
                                    onChange={(e) =>
                                        setFirstName(e.target.value)
                                    }
                                    required
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label-always-active color-highlight font-11">
                                    SecondName
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={secondname}
                                    onChange={(e) =>
                                        setSecondName(e.target.value)
                                    }
                                    required
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label-always-active color-highlight font-11">
                                    Username
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={username}
                                    onChange={(e) =>
                                        setUsername(e.target.value)
                                    }
                                    required
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label-always-active color-highlight font-11">
                                    Birth of Date
                                </label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={birth_date}
                                    onChange={(e) =>
                                        setBirthDate(e.target.value)
                                    }
                                    required
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label-always-active color-highlight font-11">
                                    Phone Number
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={phone}
                                    onChange={(e) => setPhone(e.target.value)}
                                    required
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label-always-active color-highlight font-11">
                                    Email
                                </label>
                                <input
                                    type="email"
                                    className="form-control"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label-always-active color-highlight font-11">
                                    Password
                                </label>
                                <input
                                    type="password"
                                    className="form-control"
                                    value={password}
                                    onChange={(e) =>
                                        setPassword(e.target.value)
                                    }
                                    required
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label-always-active color-highlight font-11">
                                    Confirm Password
                                </label>
                                <input
                                    type="password"
                                    className="form-control"
                                    value={confirmPassword}
                                    onChange={(e) =>
                                        setConfirmPassword(e.target.value)
                                    }
                                    required
                                />
                            </div>

                            <div className="mb-3 form-check d-flex gap-2 align-items-center">
                                <input
                                    type="checkbox"
                                    className="form-check-input p-0"
                                    id="rememberMe"
                                    checked={rememberMe}
                                    onChange={() => setRememberMe(!rememberMe)}
                                />
                                <label
                                    className="form-label-always-active color-highlight font-11 p-0"
                                    htmlFor="rememberMe"
                                >
                                    Remember this account
                                </label>
                            </div>

                            <button
                                type="submit"
                                className="btn btn-primary w-100"
                            >
                                REGISTER
                            </button>
                        </form>

                        <div className="d-flex justify-content-end mt-3">
                            <Link
                                to="/login"
                                style={{ textDecoration: "none" }}
                            >
                                Already have an account?
                            </Link>
                        </div>
                    </div>
                </div>
            )} */}
    </div>
  );
};
